import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RecordingSegmentsFetchFailedAction = {
	type: 'RECORDING_SEGMENTS_FETCH_FAILED';
	payload: ExtractedMessages;
	/** Read straight off the HTTP response — see `interviewCreationFailed.ts` for why. */
	status: number | null;
};

export default (payload: ExtractedMessages, status: number | null): RecordingSegmentsFetchFailedAction => ({
	type: 'RECORDING_SEGMENTS_FETCH_FAILED',
	payload,
	status,
});
